export default {
  /// Nhận dự toán
  BUPlan: 1,

  /// Điều chỉnh dự toán
  BUPlanAdjustment: 2,

  /// Rút dự toán
  BUPlanWithdraw: 3,

  /// Chuyển khoản kho bạc
  BUTransfer: 4,

  /// Phiếu thu
  CAReceipt: 5,

  /// Phiếu chi
  CAPayment: 6,

  /// Thu tiền gửi
  BADeposit: 7,

  /// Chi tiền gửi
  BAWithdraw: 8,

  /// Tiền đang chuyển
  BATransfer: 9,

  /// Nhập kho
  INInward: 10,

  /// Xuất kho
  INOutward: 11,

  /// Chuyển kho
  INTransfer: 12,

  /// Điều chỉnh tồn kho
  INAdjustment: 13,

  /// Ghi tăng công cụ dụng cụ
  SUIncrement: 14,

  /// Ghi giảm công cụ dụng cụ
  SUDecrement: 15,

  /// Điều chuyển công cụ dụng cụ
  SUTransfer: 16,

  /// Ghi tăng tài sản cố định
  FAIncrement: 17,

  /// Ghi giảm tài sản cố định
  FADecrement: 18,

  /// Đánh giá lại tài sản cố định
  FAAdjustment: 19,

  // Hao mòn tài sản cố định
  FADepreciation: 20,

  /// Điều chuyển phòng/ban
  FATransfer: 21, // 20,

  // Hạch toán chi phí lương
  PASalarySheet: 22,

  /// Hóa đơn mua hàng, tài sản
  PUInvoice: 23, // 21,

  /// Hóa đơn bán hàng
  SAInvoice: 24, //22,

  /// Chứng từ nghiệp vụ khác
  GLGeneralVoucher: 25, // 23,

  /// Bảng kê chứng từ thanh toán
  BUVoucherList: 26, //24,

  /// Hủy dự toán
  BUPlanCancel: 29, // 25,

  /// Điều chỉnh tạm ứng
  BUExpenseWithdrawAdjustment: 31, // 26,

  //Điều chỉnh thực chi
  BURealExpenseAdjustment: 70,

  /// Chuyển tiền nội bộ
  BABankTransfer: 36, //27,

  /// Hàng bán trả lại
  SAReturn: 37, //28,

  /// Tạm tính thuế thu nhập doanh nghiệp
  GLProvisionalTaxInComeEnterprise: 39, //29,

  /// Quyết toán thuế thu nhập doanh nghiệp
  GLFinalTaxInComeEnterprise: 40, // 30

  /// Ghi tăng TSCĐ từ QLTS.VN
  FAVoucherIncreament: 410,

  /// Đánh giá lại TSCĐ từ QLTS.VN
  FAVoucherAdjustment: 411,

  /// Khấu hao TSCĐ từ QLTS.VN
  FAVoucherDepreciate: 412,

  /// Hao mòn TSCĐ từ QLTS.VN
  FAVoucherDepreciation: 413,

  /// Ghi giảm TSCĐ từ QLTS.VN
  FAVoucherDecrement: 414,
  // Chứng từ ghi sổ
  GLPostedVoucher: 407,
};
